import React, { useState, useEffect, useRef } from 'react';

import { colors as singer_colors } from "./../data/singer-custom-colors"; 

import { colors as porsche_colors } from "../data/porsche-colors"; 

import { colors as british_motors_colors } from "../data/british-motors-colors"; 

import { capitalizeFirstLetter } from '../helpers/utils';

import TimesIcon from './icons/TimesIcon';

import PropTypes from 'prop-types';

import ListIcon from './icons/ListIcon';

import GridIcon from './icons/GridIcon';

const SingerCustomColorPicker = ( { onChangeComplete, color, onClose, color_data_key }) => {

    const custom_color_lookup = {
        'singer-custom-colors' : singer_colors,
        'porsche-colors' : porsche_colors,
        'british-motors-colors' : british_motors_colors
    }

    const colors = custom_color_lookup[ color_data_key || 'singer-custom-colors' ];

    const [ mode, setMode ] = useState( Object.keys( colors )[0] );

    const [ view, setView ] = useState( "list" );

    const [ searchString, setSearchString ] = useState( '' );

    const searchFilter = fc => searchString != "" ? fc.name.toLowerCase().indexOf( searchString.toLowerCase() ) != -1 : true;

    const height = 270;

    const scrollElRef = useRef();

    useEffect(()=>{
        setSearchString('');
        if( scrollElRef.current ) scrollElRef.current.scrollTo(0,0)
    },[mode])

    useEffect(()=>{
        if( scrollElRef.current ) scrollElRef.current.scrollTo(0,0)
    },[searchString])

    return (
        <div tabIndex={ 1 } onBlur={ e => { e.preventDefault; e.stopPropagation(); } } style={{padding:10}} >
            { Object.keys( colors ).length > 1 && <div className='d-flex' style={{gap:1, borderBottom:'1px solid #eee'}}>
                { Object.keys( colors ).map( k => (
                    <div key={`color-mode-${k}`} onClick={ () => setMode( k ) } style={{marginBottom:-2, borderRadius:'8px 8px 0 0', padding:10, backgroundColor: mode == k ? '#fff' : '#eee', border:'1px solid #eee', color: mode == k ? '#222' : '#aaa' }}>
                        <span className='bold small'>{ capitalizeFirstLetter( k ) }</span>
                    </div >
                ) ) }
                <button onClick={()=>setView('list')} style={{display:'block', marginLeft:14, marginTop:-26, color: view == 'list' ? '#000' : '#999', padding:2}}><ListIcon /></button>
                <button onClick={()=>setView('grid')} style={{display:'block', marginTop:-26, color: view == 'grid' ? '#000' : '#999', padding:2}}><GridIcon /></button>
            </div> }
            <div className='pos-rel' style={{paddingBottom:2}}>
                <input value={ searchString } onChange={ e => setSearchString( e.target.value ) } type="text" placeholder="Search" style={{borderRadius:0, border:"2px solid #eeeeee", minHeight:'unset', padding:10, backgroundColor:'#f6f6f6'}} />
                {searchString != "" && <div className="pos-abs tr-0" style={{padding:10}} onClick={()=>{ setSearchString('')}} ><TimesIcon /></div> }
            </div>
            <div className='d-flex' style={{gap:6}}>
                <div ref={ scrollElRef } className="d-flex flex-wrap overflow-y-auto bg-white align-content-start" style={ { width:210, gap: view == "grid" ? 0 : 1, height: height, borderBottom:'2px solid #eee', paddingBottom:10 } }>
                    { colors[ mode ].filter( searchFilter ).map( ( c, ci ) => {
                        const selected = color == c.hex;
                        return <div title={c.name} key={`color-swatch-${mode}-${ci}`} style={ view == "grid" ? { gap:0, flexGrow:1, padding:0, flexBasis:24, borderWidth:1, borderStyle:'solid', borderColor:'#eee', borderRadius:0 } : { borderRadius:6, gap:1, width:102, padding:4, borderWidth:2, borderStyle:'solid', borderColor:'#eee' }} className={`${selected ? 'brdr-admin-secondary' : ''} pointer d-flex flex-column`} onClick={ () => onChangeComplete( c ) } >
                            <div className='w-100' style={{height: view == "grid" ? 18 : 10, backgroundColor:c.hex}}></div>
                            <span title={c.name} style={{display: view == "grid" ? 'none' : 'block', fontSize:'11px', width:'100%', overflow:'hidden', whiteSpace:'nowrap', lineHeight:1}}>{c.name}</span>
                        </div>
                    } ) }
                </div>
                {/* <div>
                    { colors[ mode ].filter( searchFilter ).map( c => {
                        return <div className="pointer rounded-6" onClick={ () => onChangeComplete( c ) } style={ { width: 20  } }>
                            <div className='w-100' style={ { height:  height / ( colors[ mode ].length ) , backgroundColor: c.hex } }></div>
                        </div>
                    }   ) }
                </div> */}
            </div>
            <button style={{padding:"6px 6px"}} className="pos-abs tr-0 rounded-4 bg-black text-white" onClick={ onClose }>
                <TimesIcon />
            </button>
        </div>
    )
}

SingerCustomColorPicker.propTypes = {
    onChangeComplete: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    color: PropTypes.string.isRequired,
    color_data_key : PropTypes.string
}

export default SingerCustomColorPicker;